import { useBoxStyle } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useKeyboard } from "../../OS/useKeyboard";
import { Platform, StyleProp, ViewStyle } from "react-native";
import { listGutterStyle } from "./guterStyle";

export function useOrgHomeDetailContainerStyle(): StyleProp<ViewStyle> {
  const insets = useSafeAreaInsets();
  return [
    useBoxStyle({
      spaceHorizontal: "medium",
      spaceBottom: "xlarge",

      insets: {
        bottom: insets.bottom,
      },
    }),
    {
      maxWidth: 900,
      minWidth: 650,
      width: "100%",
      alignSelf: "center",
    },
  ];
}

export function useOrgHomeDetailLayout() {
  const keyboard = useKeyboard();
  const contentContainerStyle = useOrgHomeDetailContainerStyle();
  return {
    contentContainerStyle,
    keyboardBottomInset:
      Platform.OS === "ios" ? keyboard.availableRect.bottom : undefined,
    keyboardShown: keyboard.keyboardShown,
  };
}

export function useOrgListStyleProps() {
  const detailLayout = useOrgHomeDetailLayout();

  return {
    style: [
      listGutterStyle,
      { flex: 1, marginBottom: detailLayout.keyboardBottomInset },
    ],
    contentContainerStyle: detailLayout.contentContainerStyle,
  };
}
